<template>
  <app-card
    title="Ferienwohnung Sabrina"
    :images="images"
    :seasonalPrices="seasonalPrices"
  ></app-card>
</template>

<script>
import appartmentCardVue from '../components/appartment-card.vue'

export default {
  name: 'sabrina',
  data () {
    return {
      images: [
        {
          src: 'app2/Bad.jp2',
          description: 'Badezimmer',
          thumbnail: 'app2/Bad-300.jp2'
        },
        {
          src: 'app2/Balkon.jp2',
          description: 'Balkon',
          thumbnail: 'app2/Balkon-300.jp2'
        },
        {
          src: 'app2/Kueche-1.jp2',
          description: 'Küche',
          thumbnail: 'app2/Kueche-1-300.jp2'
        },
        {
          src: 'app2/Kueche-2.jp2',
          description: 'Küche',
          thumbnail: 'app2/Kueche-2-300.jp2'
        },
        {
          src: 'app2/Schlafzimmer.jp2',
          description: 'Schlafzimmer',
          thumbnail: 'app2/Schlafzimmer-300.jp2'
        },
        {
          src: 'app2/Wohnzimmer-1.jp2',
          description: 'Wohnzimmer',
          thumbnail: 'app2/Wohnzimmer-1-300.jp2'
        },
        {
          src: 'app2/Wohnzimmer-2.jp2',
          description: 'Wohnzimmer',
          thumbnail: 'app2/Wohnzimmer-2-300.jp2'
        }
      ],
      seasonalPrices: [
        {
          start: '2024-01-05',
          end: '2025-06-28',
          saison: 'B',
          price: 120
        },
        {
          start: '2025-06-29',
          end: '2025-09-13',
          saison: 'A',
          price: 140
        },
        {
          start: '2025-09-14',
          end: '2025-12-20',
          saison: 'B',
          price: 120
        },
        {
          start: '2025-12-21',
          end: '2026-01-03',
          saison: 'A',
          price: 140
        }
      ]
    }
  },
  components: {
    'app-card': appartmentCardVue
  },
  mounted () {
    /*
    const req = require.context('../../public/app2', true, /\.(jpg)$/i)
    req.keys().map(img => {
      if (!img.includes('-300')) {
        if (!img.includes('-300')) {
          var imgObj = {
            src: 'app2/' + img,
            description: img,
            thumbnail: 'app2/' + img.replace('.jp2', '') + '-300.jp2'
          }
          this.images.push(imgObj)
        }
      }
    })
    */
  }
}
</script>

<style lang="scss" scoped>
</style>
